import {defaultMarkdownSerializer, MarkdownSerializer, MarkdownSerializerState} from 'prosemirror-markdown';
import {escapeHtml} from '../Common/escapeHtml';

MarkdownSerializerState.prototype.esc = function esc(str, startOfLine) {
    str = str.replace(/[`*\\~\[\]{}]/g, "\\$&");

    if (startOfLine) {
        str = str.replace(/^[:#\-*+]/, "\\$&").replace(/^(\d+)\./, "$1\\.");
    }

    return str;
};

export const markdownSerializer = (nodeSerializers, markSerializers) => new MarkdownSerializer({
        ...defaultMarkdownSerializer.nodes,
        ...nodeSerializers
    }, {
        ...defaultMarkdownSerializer.marks,
        ...markSerializers,
        link: {
            open: function open(state, mark, parent, index) {
                return defaultMarkdownSerializer.marks.link.open(state, mark, parent, index);
            },
            close: function close(state, mark, parent, index) {
                let closeLink = defaultMarkdownSerializer.marks.link.close(state, mark, parent, index);
                if (mark.attrs['data-id']) {
                    closeLink += `{data-id="${escapeHtml(mark.attrs['data-id'])}"`;

                    if (mark.attrs['data-size']) {
                        closeLink += ` data-size="${escapeHtml(mark.attrs['data-size'])}"`;
                    }
                    if (mark.attrs['data-type']) {
                        closeLink += ` data-type="${escapeHtml(mark.attrs['data-type'])}"`;
                    }
                    if (mark.attrs.error) {
                      closeLink += ` error=""`;
                    }
                    closeLink += '}';
                } else if (mark.attrs.button) {
                  closeLink += `{class="ui button${mark.attrs.color ? ` ${mark.attrs.color}` : ''}"`;
                  if (mark.attrs.color) {
                    closeLink += ` data-color="${mark.attrs.color}"`;
                  }
                  closeLink += '}';
                }
                return closeLink;
            }
        }
    }
);